module.exports = __webpack_public_path__ + "static/media/brand6.eff6873b.png";